/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Quick_Fill_TitleInputs */

const vi_stocktake_quick_fill_title = /** @type {(inputs: Stocktake_Quick_Fill_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điền số hệ thống`)
};

/**

* @param {Stocktake_Quick_Fill_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_quick_fill_title = /** @type {((inputs?: Stocktake_Quick_Fill_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Quick_Fill_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_quick_fill_title(inputs)
});